export const ReportRoutes = [];
